import { run } from './liveIndex';
import { registerTranslationsForMts } from 'easit--utils';

let isLocalDevelopment = process.env.NODE_ENV === 'development';

registerTranslationsForMts();

if (isLocalDevelopment) {
    run();
} else {
    window["runReactApp"] = run; //TODO use window interface ? (window.runReactApp() is called in different place than script include)
}